import { type Control, Controller, type FieldPath, type FieldValues } from "react-hook-form";
import { Card } from "../../ui/Card";
import { RichTextEditor } from "../../ui/RichTextEditor";

type FormCommentProps<TFieldValues extends FieldValues, TTransformedValues = TFieldValues> = {
	control: Control<TFieldValues, any, TTransformedValues>;
	name: FieldPath<TFieldValues>;
	className?: string;
	contentClassName?: string;
	placeholder?: string;
};

export const FormComment = <TFieldValues extends FieldValues, TTransformedValues = TFieldValues>(
	props: FormCommentProps<TFieldValues, TTransformedValues>,
) => {
	return (
		<Controller
			{...props}
			render={({ field: { ref, ...field } }) => {
				return (
					<Card>
						<RichTextEditor
							content={field.value}
							onUpdate={(html) => field.onChange(html)}
							isComment
						/>
					</Card>
				);
			}}
		/>
	);
};
